module.exports = __webpack_public_path__ + "img/general.6d0375a5.jpg";